
import React from 'react';
import { connect } from 'react-redux';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';
import { setUserDetails } from '../../General/Actions.js';
import { setCache } from '../../General/Actions.js';
import ApuaBlueTextLogo from '../../ImageAssets/Apua_New_Logo.png';
// import ApuaBlueTextLogo from '../../ImageAssets/ApuaBlueTextLogo.png';
import Dot from '../../ImageAssets/dots.png';
import { FaUser } from 'react-icons/fa';
import { Button } from 'reactstrap';
import PopupModal from '../../Utils/modalComponent.js';

class SelectAllAccountComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            accountName: "",
            allAccountList: [],
            contentForPopup: "",
            headingForPopup: "",
            isSubmitButtonVisibleForPopup: true,
            isCancelButtonVisibleForPopup: true,
            isSwalVisible: false
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        console.log("this.props.userDetails.accounts>>", this.props.userDetails.accounts);
        console.log("account cache>>", this.props.cache.getAllAccountsResponse);
        // //Network.executeAxios("getAllAccounts", "POST", {}, (getAllAccountsResponse) => {
        //     // this.props.setCache("getAllAccountsResponse", getAllAccountsResponse);
        //     var getAllAccountsResponse = this.props.cache.getAllAccountsResponse;
        //     var currentBasicDetails = []; 
        //     try{
        //         currentBasicDetails = getAllAccountsResponse.BillingSystem.response.dataset.basicDetails;
        //     }catch(err){
        //         currentBasicDetails = [];
        //     }
        //     var allAccounts = [];
        //     for(var i=0;i<currentBasicDetails.length;i++){
        //         var tempObject = {
        //             "accountId":currentBasicDetails[i].account_id
        //         };
        //         allAccounts.push(tempObject);
        //     }
        //     this.props.setUserDetails("accounts",allAccounts);
        try {
            var currentBasicDetails = [];
            var getAllAccountsResponse = this.props.cache.getAllAccountsResponse;
            currentBasicDetails = getAllAccountsResponse.BillingSystem.response.dataset.account_info[0]

            // var firstName="";
            // var lastName="";
            // var finalName="";
            //  firstName=currentBasicDetails.first_name;
            //  lastName=currentBasicDetails.last_name;
            //  finalName =firstName +" "+lastName;
            this.state.accountName = currentBasicDetails.profile_name
        } catch (err) {
            currentBasicDetails = [];
        }
        this.setState({ "dummy": "dummy" })
        // //});
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    optionsButtonClicked(type, needConfirmation) {
        if (type === "logout") {
            if (needConfirmation) {
                Swal.fire({
                    title: this.props.locales.logoutConfirmationTitleInSwal,
                    text: "",
                    type: '',
                    showCancelButton: true,
                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) { this.optionsButtonClicked("logout"); }
                });
            } else {
                Network.executeAxios("logout", "GET", {}, (response) => {
                    if (response.STATUS === "SUCCESS") {
                        localStorage.removeItem("isUserLoggedIn");
                        localStorage.removeItem("currentAccount");
                        window.location.reload()
                    } else {
                        Swal.fire(this.props.locales.selectAllAccCompLogoutFailedSwal, "", "");
                    }
                });
            }
        }
    }

    showSwal = (title, message, type, callback) => {
        this.setState({
            isSwalVisible: true,
            headingForPopup: title,
            contentForPopup: message
        })
        this.state.swalCallBack = callback
        this.setState({ "dummy": "dummy" })
    }

    customSwalEvent = (dataObject) => {
        if (dataObject.type === "cancel") {
            if (this.state.swalCallBack) {
                this.setState({ isSwalVisible: false, swalCallBack: false });
            }
        } else {
            if (this.state.swalCallBack) {
                this.state.swalCallBack()
                this.setState({
                    isSwalVisible: false
                })
            }
        }
    }

    selectAccountLinkClicked(receivedAccountId) {
        Network.executeAxios("changeAccountIdInSession", "POST", { "newAccountId": receivedAccountId, "isFirstTime": false }, (changeAccountIdInSessionResponse) => {
            if (changeAccountIdInSessionResponse.STATUS === "SUCCESS") {
                this.props.setUserDetails("currentAccount", receivedAccountId);
                this.props.reInitialize(receivedAccountId);
            } else {
                Swal.fire(this.props.locales.selectAllAccCompAccSwitchFailedSwal, "", "");
            }
        });
    }

    populateAllAcounts() {
        var finalAccountList = [];
        var values = [];
        var value;

        for (var i = 0; i < this.props.userDetails.accounts.length; i++) {
            value = this.props.userDetails.accounts[i].accountId;

            if (values.indexOf(value) == -1) {
                finalAccountList.push(this.props.userDetails.accounts[i]);
                values.push(value);
            }
        }
        this.state.allAccountList = finalAccountList;
        const allAccounts = this.state.allAccountList.map((item, key) => {
            //let userName= item.first_name+" "+item.last_name;
            let userName = "" + item.account_name;
            return (
                <div className="col-md-4 mb-4 " style={{}} key={key}>
                    <div className="allAccountDetail d-flex mx-auto align-items-center" onClick={() => this.selectAccountLinkClicked(item.accountId)}>
                        <div className=" px-1 text-center">
                            <div className="iconContainer ">
                                <FaUser style={{ fontSize: 20, marginTop: 14 }} />
                            </div>
                        </div>
                        <div className="pl-3 p-0" style={{ width: '100%' }}>
                            <div className="" style={{ fontSize: 19, fontWeight: 500, color: '#404042' }}>{userName}</div>
                            <div className="" style={{ fontSize: 14, fontWeight: 500, color: '#404042' }}>{item.accountId}</div>
                            <div className="" style={{ fontSize: 16, fontWeight: 300, color: '#6D6D6D' }}>{item.notification_email_id}</div>
                        </div>
                    </div>
                </div>
            );
        });
        return (<div className="allAccountDetailContainer col-md-12 row" style={{ marginTop: '-3%', backgroundColor: 'transparent' }}>{allAccounts}</div>)
    }

    render() {
        return (
            <div className="animated fadeIn" id="allAccountsMainDiv" style={{ height: this.state.windowHeight + 100 + 'px' }}>
                {/* {this.topBannerComponent()} */}
                <div className="col-md-12 p-0" style={{ backgroundColor: '#ffffff' }}>
                    <div className=" d-flex justify-content-between py-3 align-items-center" style={{ backgroundColor: '#ffffff', width: '88%', marginLeft: 'auto', marginRight: 'auto', minHeight: 70 }}>
                        <div className="text-left headerImage"><img src={ApuaBlueTextLogo} alt="" height="55" /></div>
                        <div className="text-right d-flex">
                            <div className="d-flex align-items-center">
                                <div className="" style={{ color: '#414042', fontWeight: 500, fontSize: 16 }}>{this.state.accountName}</div>
                            </div>
                            <div>
                                <Button color="link" className="logoutButton ml-3" style={{ backgroundColor: 'rgba(0,73,165,0.1)', color: '#0049A5', borderRadius: '50%' }} onClick={() => { this.optionsButtonClicked("logout", true) }}><FaUser style={{ marginTop: '-5' }} /></Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="populateAccountDiv">
                    <div className="col-md-12" style={{ height: 145, position: 'relative', boxShadow: 'rgb(0 0 0 / 15%) 0px 8px 20px -8px inset' }}>
                        <div className="ml-auto mr-auto pt-4" style={{ width: '89%' }}>
                            <div style={{ fontSize: 24, color: '#33495F' }}>{this.props.locales.welcomeTextInOverview} <span style={{ fontWeight: 500 }}> {this.state.accountName} </span></div>
                            <div style={{ fontSize: 14, color: '#33495F' }}>{this.props.locales.selectAllAccCompSelectAnAccTxt}</div>
                        </div>
                        <div style={{ position: 'absolute', background: `url(${Dot})`, height: 100, width: 150, top: 0, right: 0 }}></div>
                    </div>
                    <div className="col-md-12">
                        {this.populateAllAcounts()}
                    </div>
                </div>
                <PopupModal
                    isVisible={this.state.isSwalVisible}
                    uniqueModalReferenceId=""
                    content={this.state.contentForPopup}
                    mainHeading={this.state.headingForPopup}
                    isCancelButtonVisible={this.state.isCancelButtonVisibleForPopup}
                    isSubmitButtonVisible={this.state.isSubmitButtonVisibleForPopup}
                    cancelButtonText={this.state.cancelButtonText}
                    callback={this.customSwalEvent}
                />
            </div>

        );
    }

    // topBannerComponent() {
    //     return (
    //         <div className="py-1" style={{ background: 'linear-gradient(90deg, #FF0026 0%, #E21736 100%)', width: '100%' }}>
    //             <div style={{marginLeft:'auto',marginRight:'auto',width:'88%'}} className=" d-flex justify-content-between">
    //                 <div className="" style={{color:"#ffffff",fontWeight:500,fontSize:16,cursor:'pointer'}}
    //                     onClick={(e) => {
    //                         e.preventDefault();
    //                         window.location.href='https://www.hargray.com/contact-us';
    //                       }}>
    //                  <span style={{textDecoration:'underline'}}>Contact us</span>  <span style={{ marginLeft:10}}>(877.427.4729)</span>
    //                 </div>
    //                 <div className="" style={{color:"#ffffff",fontWeight:500,fontSize:16,cursor:'pointer'}}
    //                 onClick={(e) => {
    //                     e.preventDefault();
    //                     window.location.href='https://www.hargray.com/support';
    //                     }}>
    //                     FAQ
    //                 </div>


    //             </div>
    //         </div>
    //     );
    // }

    topBannerComponent() {
        return (
            <div className="py-1" style={{ backgroundColor: 'rgba(0,0,0,0.9)', width: '100%' }}>
                <div style={{ marginLeft: 'auto', marginRight: 'auto', width: '88%' }} className=" d-flex justify-content-between">
                    <div className="" style={{ color: "#ffffff", fontSize: 16, cursor: 'pointer' }}
                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = 'https://www.hargray.com';
                        }}>
                        <span style={{ fontWeight: 500 }}>MY HARGRAY</span>
                        <span style={{ marginLeft: 55 }}>SHOP/UPGRADE</span>
                        <span style={{ marginLeft: 55 }}>SUPPORT</span>
                        <span style={{ marginLeft: 55 }}>BUSINESS</span>
                    </div>
                    <div className="" style={{ color: "#ffffff", fontSize: 16, cursor: 'pointer' }}
                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = 'https://www.hargray.com/support';
                        }}>
                        FAQ
                    </div>


                </div>
            </div>
        );
    }
}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        userDetails: state.userDetails
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        },
        setUserDetails: function (key, payload) {
            dispatch(setUserDetails(key, payload));
        }
    }
}

const SelectAllAccountComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectAllAccountComponent)

export default SelectAllAccountComponentContainer;
